
import Badge from 'vux/src/components/badge/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: "",
props: [""],
data() {
return {
userInfo: {},
apiurl: "",
mangersystemInfo: {
url: 'https://ms.yuyuejl.com'
}
};
},

components: {
Badge,
Group,
Cell
},

created() {
this.$http.get("./static/api/api.json").then(response => {
this.apiurl = response.api;
this.getUserinfo();
});
},

beforeMount() {},

mounted() {

},
methods: {
getUserinfo() {
this.$http.get(this.apiurl + "/web/member/info").then(res => {
if (res.code === 0) {
this.userInfo = res.data;
}
});
},













},

watch: {}
};




// WEBPACK FOOTER //
// ./src/components/personal.vue